export const themes = [
  {
    id: "volt",
    name: "Volt",
    description: "Carbon / electric lime",
    accent: "#c9ff32",
    background: "#080b0b",
  },
  {
    id: "glacier",
    name: "Glacier",
    description: "Midnight / ice blue",
    accent: "#8bdfff",
    background: "#080f19",
  },
  {
    id: "ember",
    name: "Ember",
    description: "Warm charcoal / apricot",
    accent: "#ffb184",
    background: "#140e0c",
  },
  {
    id: "iris",
    name: "Iris",
    description: "Ink / soft violet",
    accent: "#c5b2ff",
    background: "#100d18",
  },
] as const;

export type ThemeId = (typeof themes)[number]["id"];
// To settle on a palette, choose its id and turn off the switcher.
export const DEFAULT_THEME: ThemeId = "iris";
export const THEME_SWITCHER_ENABLED: boolean = false;
export const THEME_STORAGE_KEY = "performance-lab-theme";

export function readTheme(): ThemeId {
  if (!THEME_SWITCHER_ENABLED || typeof window === "undefined")
    return DEFAULT_THEME;
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    return themes.find((theme) => theme.id === saved)?.id ?? DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
}

export function applyTheme(id: ThemeId) {
  const theme = themes.find((item) => item.id === id)!;
  document.documentElement.dataset.palette = id;
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", theme.background);
}
